// @flow
import React from 'react'
import styled from 'styled-components'
import Colors from 'components/styles/colors'
import { mediaMax } from 'frontend_core/dist/styles/media'
import Map from 'components/organisms/SearchMap'
import RoomMedia from 'components/molecules/RoomMedia'
import SearchingView from 'components/organisms/SearchProgressModal'
import Pager, {
  type PropTypes as PagerType,
} from 'components/organisms/ListPager'

const SideBar = styled.div`
  position: relative;
  float: left;
  width: 312px;
  ${mediaMax.desktop`
    display: none;
    width: 100%;
    height: 100vh;
    padding: 12px 0;
    overflow-y: scroll;
    z-index: 100;
    top: 0;
    background-color: ${Colors.white};
  `};
`
const Main = styled.div`
  float: right;
  width: 100%;
  margin-left: -312px;
  padding-left: 312px;
  ${mediaMax.desktop`
    margin-left: 0;
    padding-left: 0;
  `};
`
const Inner = styled.div`
  padding: 0 12px;
`
const AllContainer = styled.div`
  width: 100%;
  ${mediaMax.desktop`
    padding: 0;
  `};
`
const SearchResultHead = styled.div`
  padding: 24px 12px 12px;
`
const SearchResultTitle = styled.h1`
  float: left;
  color: ${Colors.black};
`
const SearchResultBackLink = styled.a`
  position: relative;
  display: block;
  float: right;
  padding-left: 8px;
  color: ${Colors.blue};
  font-size: 12px;

  &:hover {
    text-decoration: underline;
  }

  &::before {
    position: absolute;
    top: 50%;
    left: 0;
    margin-top: -3px;
    width: 6px;
    height: 6px;
    border-top: 1px solid ${Colors.blue};
    border-right: 1px solid ${Colors.blue};
    transform: rotate(-135deg);
    content: '';
  }
`
const SearchResultListItem = styled.li`
  &:hover {
    background-color: ${Colors.grayF};
  }

  &[data-search-status='isSelect'] {
    border-left: 4px solid ${Colors.blue};
    background-color: ${Colors.grayF};
  }
`
const SearchScrollContainer = styled.div`
  height: calc(100vh - 214px);
  overflow-y: scroll;
`
const MapBottomSp = styled.div`
  display: none;
  ${mediaMax.desktop`
    display: block;
    padding: 0 12px;
    height: 60px;
  `};
`
const MapBottomPager = styled.div``
const RoomLink = styled.div`
  display: block;
  cursor: pointer;
`

export type PropTypes = {
  roomList: Array<{
    id: number,
    name: string,
    capacity: number,
    reputationScore: number,
    reputationCount: number,
    address: string,
    access: string,
    price: string,
    priceUnit: string,
    latitude: number | string,
    longitude: number | string,
    roomLink: string,
    thumbnail: string,
    isDirectReservation: boolean,
    isTopHost: boolean,
    isLastMinutesDiscount: boolean,
  }>,
  latitude: number,
  longitude: number,
  selectedRoomId: number,
  isShowRoomAnnotation: boolean,
  isShowReSearchButton: boolean,
  pagerProps: PagerType,
  listViewLink?: string,
  onChangeSelectedRoom: Function,
  onLinkToSearch: Function,
  onClickMarker: Function,
  onRefSearchScrollContainer: Function,
  onRefRoomMedia: Function,
  onChangeMap: Function,
  onDragMap: Function,
  onClickReSearch: Function,
  onChangeCheckMovingSearch: Function,
  isLoading: boolean,
  googleMapReactBootstrapURLKeys?: ?Object,
}

export default (props: PropTypes) => (
  <AllContainer className="clearfix">
    <SideBar>
      {/*
        一覧からMapに変わる時(data.refetch)の時にdata.loadingがtrueで止まるバグ対応のため、
        Modalを出すのを止めている。
        props.isLoading &&
        <SearchingView SearchingViewType="map" />
        */}
      <Inner>
        <SearchResultHead className="clearfix">
          <SearchResultTitle>
            {i18n.t('page.search.searchResult')}
          </SearchResultTitle>
          <SearchResultBackLink
            href={props.listViewLink}
            onClick={e => {
              e.preventDefault()
              props.onLinkToSearch(e)
            }}
          >
            {i18n.t('page.search.listView')}
          </SearchResultBackLink>
        </SearchResultHead>
        <SearchScrollContainer
          innerRef={ref => props.onRefSearchScrollContainer(ref)}
        >
          <ul>
            {props.roomList.map((room, index) => (
              <SearchResultListItem
                key={`SearchResultListItem${index}`}
                data-search-status={
                  props.selectedRoomId === room.id ? 'isSelect' : ''
                }
              >
                <RoomLink
                  onClick={e => {
                    e.preventDefault()
                    window.open(room.roomLink)
                  }}
                  onMouseEnter={e => {
                    e.preventDefault()
                    props.onChangeSelectedRoom(room)
                  }}
                >
                  <RoomMedia {...room} onRef={props.onRefRoomMedia} />
                </RoomLink>
              </SearchResultListItem>
            ))}
          </ul>
        </SearchScrollContainer>
        <Pager {...props.pagerProps} windowSize={2} borderType="minus" />
      </Inner>
    </SideBar>
    <Main>
      <div>
        <Map {...props} />
        <MapBottomSp>
          <MapBottomPager>
            <Pager {...props.pagerProps} windowSize={0} layoutType="row" />
          </MapBottomPager>
        </MapBottomSp>
      </div>
    </Main>
  </AllContainer>
)



// WEBPACK FOOTER //
// ./src/components/pages/SearchPage/Map.jsx